// Product type constants for ethanol/gallons support
// NOTE: For reports, product categorization is now driven by Sand_Types.bol_template
// in the database. The arrays below are used for UI filtering (tabs, dropdowns).

// Physical conversion factor - must match api/constants/productTypes.js
export const ETHANOL_LBS_PER_GALLON = 6.6

// Weight validation ranges
export const TARE_WEIGHT_MIN = 15000
export const TARE_WEIGHT_MAX = 80000

// Temperature validation range (degrees Fahrenheit, ethanol BOLs only)
export const TEMPERATURE_MIN = -50
export const TEMPERATURE_MAX = 125

// Storage capacities
export const SAND_RAILCAR_CAPACITY_LBS = 230000
export const ETHANOL_RAILCAR_CAPACITY_GAL = 29000

// Unit of measure types
export const UOM_LBS = 'lbs'
export const UOM_GALLONS = 'gallons'

// BOL template types (matches Sand_Types.bol_template values in database)
export const BOL_TEMPLATE_SAND = 'sand'
export const BOL_TEMPLATE_CEMENT = 'cement'
export const BOL_TEMPLATE_ETHANOL = 'ethanol'

// Product arrays for UI filtering (tabs, dropdowns)
// These should be kept in sync with Sand_Types table entries
export const SAND_PRODUCTS = ['100M NW', '40/70 NW', '30/50 NW', '40/140 NW']
export const CEMENT_PRODUCTS = ['Cement']
export const ETHANOL_PRODUCTS = ['Ethanol']

// Terminals that handle multiple product types (ethanol, cement, sand)
export const ETHANOL_TERMINALS = ['Binghamton']

// Unit configuration - used for UI display
const UNIT_CONFIG = {
  [UOM_GALLONS]: { label: 'gal', fullLabel: 'gallons', capacity: ETHANOL_RAILCAR_CAPACITY_GAL },
  [UOM_LBS]: { label: 'lbs', fullLabel: 'lbs', capacity: SAND_RAILCAR_CAPACITY_LBS }
}

const getUnitConfig = uom => UNIT_CONFIG[uom] ?? UNIT_CONFIG[UOM_LBS]

// Helper functions for product type detection
export const isEthanolProduct = sandType =>
  sandType && ETHANOL_PRODUCTS.some(p => p.toLowerCase() === sandType.toLowerCase())

export const isCementProduct = sandType =>
  sandType && CEMENT_PRODUCTS.some(p => p.toLowerCase() === sandType.toLowerCase())

// Terminal check for multi-product UI
export const isEthanolTerminal = terminal => ETHANOL_TERMINALS.some(t => t === terminal)

// Get BOL template based on sand_type
export const getBolTemplate = sandType => {
  if (isEthanolProduct(sandType)) return BOL_TEMPLATE_ETHANOL
  if (isCementProduct(sandType)) return BOL_TEMPLATE_CEMENT
  return BOL_TEMPLATE_SAND
}

// Unit conversion utilities
export const convertGallonsToLbs = gallons => gallons * ETHANOL_LBS_PER_GALLON
export const convertLbsToGallons = lbs => lbs / ETHANOL_LBS_PER_GALLON

// Unit label helpers
export const getUnitLabel = uom => getUnitConfig(uom).label
export const getFullUnitLabel = uom => getUnitConfig(uom).fullLabel
export const getRailcarCapacity = uom => getUnitConfig(uom).capacity
